// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"87091f03","531":"45c62dd3","667":"681ecefb","690":"2ca168c2","787":"bd46f37b","820":"cc3f5cff","877":"fb7aabb0"}[chunkId] + ".chunk.js";
};